import React from 'react';
import text from '../../text';
var Header = function() {
    return /*#__PURE__*/ React.createElement("h2", {
        className: "green-1 text-center"
    }, text('joinTheBestInTheIndustry'));
};
export default Header;
